import { useTlgLink } from './useTlgLink';

export const useContactFormLink = () => {
  return `${useTlgLink()}/contact`;
};
